import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select } from "antd";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./ProfileForm.css";
import { useLocation } from 'react-router-dom';

const ClientForm = ({ client, extraData, onSave, onCancel }) => {
  const [form] = Form.useForm();
  const [showExtraFields, setShowExtraFields] = useState(false);
  const [showSpouseName, setShowSpouseName] = useState(false);
  const [value, setValue] = useState("");
    const location = useLocation();
    const isAdmin = location.pathname.includes('admin');


  useEffect(() => {
    if (client) {
      setShowExtraFields(true);
      const updatedClient = {
        ...client,
        name: client?.name == null ? "" : client?.name,
        spouse_name: client?.spouse_name == null ? "" : client?.spouse_name,
      };
      setValue(updatedClient.phone_number || "");
      form.setFieldsValue(updatedClient);
    } else {
      if (extraData) {
        setShowSpouseName(true);
      }
      setShowExtraFields(false);
      form.resetFields();
    }
  }, [client, form]);

  const handleSubmit = (values) => {
    const finalValues = {
      ...values,
      phone_number: value,
    };
    const filteredValues = Object.fromEntries(
        Object.entries(finalValues).filter(([_, val]) => val !== undefined)
    );
    onSave(filteredValues);
  };

  return (
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        {showExtraFields && (
            <>
              <Form.Item name="id" label="ID" style={{ display: "none" }}>
                <Input disabled />
              </Form.Item>
            </>
        )}

        <Form.Item
            name="first_name"
            label="First Name"
            rules={
              (["agent", "broker"].includes(client?.role) || showSpouseName === false) &&
              !["contact", "client"].includes(client?.role)
                  ? [{ required: true, message: "Please enter the name" }]
                  : []
            }
        >
          <Input />
        </Form.Item>

        <Form.Item name="middle_name" label="Middle Name">
          <Input />
        </Form.Item>

        <Form.Item
            name="last_name"
            label="Last Name"
            rules={
              (["agent", "broker"].includes(client?.role) || showSpouseName === false) &&
              !["contact", "client"].includes(client?.role)
                  ? [{ required: true, message: "Please enter the name" }]
                  : []
            }
        >
          <Input />
        </Form.Item>

        <Form.Item name="suffix" label="Suffix">
          <Input maxLength={4} />
        </Form.Item>

        <Form.Item
            name="email"
            label="Email"
            rules={
              (["agent", "broker"].includes(client?.role) || showSpouseName === false) &&
              !["contact", "client"].includes(client?.role)
                  ? [{ required: true, message: "Please enter the email" }]
                  : []
            }
        >
          <Input />
        </Form.Item>

          {(client?.role === 'agent' || showSpouseName === false) && (
              (client?.role !== 'contact' &&   client?.role !== 'client') ? (
                  <Form.Item
                      name="license"
                      label="License"
                      rules={
                          isAdmin
                              ? []
                              : [{ required: true, message: 'Please enter the license key' }]
                      }
                  >
                      <Input disabled={isAdmin} />
                  </Form.Item>
              ) : null
          )}

          <Form.Item
              label="Phone Number"
              name="phone_number"
              rules={
                  isAdmin
                      ? []
                      : [{ required: true, message: 'Please enter the phone number' }]
              }
          >
              <PhoneInput
                  defaultCountry="US"
                  placeholder="Enter phone number"
                  value={value}
                  required
                  onChange={setValue}
                  error={
                      value
                          ? isValidPhoneNumber(value)
                          ? undefined
                          : "Invalid phone number"
                          : "Phone number required"
                  }
              />
          </Form.Item>

        {showSpouseName && (
            <Form.Item name="spouse_name" label="Spouse Name">
              <Input />
            </Form.Item>
        )}

        {showExtraFields && (
            <>
              <Form.Item name="role" label="Status">
                <Select>
                  <Select.Option value="client">Client</Select.Option>
                  <Select.Option value="contact">Contact</Select.Option>
                  <Select.Option value="broker">Broker</Select.Option>
                </Select>
              </Form.Item>

              {["contact", "client"].includes(client?.role) && (
                  <>
                    <Form.Item name="expiry_date" label="Client Expiration Date">
                      <Input disabled />
                    </Form.Item>
                    <p>(determined via signed document field)</p>
                  </>
              )}
            </>
        )}

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
          <Button style={{ marginLeft: "8px" }} onClick={onCancel}>
            Cancel
          </Button>
        </Form.Item>
      </Form>
  );
};

export default ClientForm;




























// import React, { useState, useEffect } from "react";
// import {Form, Input, Button, Select} from "antd";
// import PhoneInput, {isValidPhoneNumber} from "react-phone-number-input";
// import 'react-phone-number-input/style.css'
// import './ProfileForm.css';
//
// const ClientForm = ({ client,extraData, onSave, onCancel }) => {
//   const [form] = Form.useForm();
//   const [showExtraFields, setShowExtraFields] = useState(false); // Control extra fields
//   const [showSpouseName , setShowSpouseName] = useState(false);
//   const [value , setValue] = useState('');
//
//   useEffect(() => {
//     if (client) {
//       setShowExtraFields(true);
//         const updatedClient = {
//             ...client,
//             name: client?.name == null ? '' : client?.name,
//             spouse_name: client?.spouse_name == null ? '' : client?.spouse_name,
//         };
//
//         form.setFieldsValue(updatedClient);
//     } else {
//       if (extraData){
//         setShowSpouseName(true);
//       }
//       setShowExtraFields(false);
//       form.resetFields();
//     }
//   }, [client, form]);
//
//   const handleSubmit = (values) => {
//       const filteredValues = Object.fromEntries(
//           Object.entries(values).filter(([key, value]) => value !== undefined)
//       );
//       onSave(filteredValues);
//   };
//
//   return (
//     <Form form={form} layout="vertical" onFinish={handleSubmit}>
//       {showExtraFields && (
//         <>
//           <Form.Item name="id" label="ID" style={{ display: 'none' }}>
//             <Input disabled={true} />
//           </Form.Item>
//         </>
//       )}
//
//       <Form.Item
//         name="first_name"
//         label="First Name"
//         rules={
//                 (client?.role === 'agent' || showSpouseName === false) &&
//                 (client?.role !== 'contact' && client?.role !== 'client')
//                     ? [{ required: true, message: "Please enter the name" }]
//                     : []
//             }
//       >
//         <Input />
//       </Form.Item>
//
//       <Form.Item
//         name="middle_name"
//         label="Middle Name"
//         >
//             <Input />
//         </Form.Item>
//
//       <Form.Item
//         name="last_name"
//         label="Last Name"
//         rules={
//                 (client?.role === 'agent' || showSpouseName === false) &&
//                 (client?.role !== 'contact' && client?.role !== 'client')
//                     ? [{ required: true, message: "Please enter the name" }]
//                     : []
//             }
//       >
//         <Input />
//       </Form.Item>
//
//        <Form.Item
//         name="suffix"
//         label="Suffix"
//         // rules={
//         //     (client?.role === 'agent' || showSpouseName === false) &&
//         //     (client?.role !== 'contact' && client?.role !== 'client')
//         //         ? [{ required: true, message: "Please enter the suffix" }]
//         //         : []
//         //   }
//         >
//             <Input maxLength={4} />
//         </Form.Item>
//
//       <Form.Item
//         name="email"
//         label="Email"
//         rules={
//             (client?.role === 'agent' || showSpouseName === false) &&
//             (client?.role !== 'contact' && client?.role !== 'client')
//                 ? [{ required: true, message: "Please enter the suffix" }]
//                 : []
//         }
//       >
//         <Input />
//       </Form.Item>
//
//         {(client?.role === 'agent' || showSpouseName === false) && (
//             (client?.role !== 'contact' &&   client?.role !== 'client') ? (
//         <Form.Item
//             name="license"
//             label="License"
//             rules={[{ required: true, message: "Please enter the license key" }]}
//         >
//             <Input />
//         </Form.Item>
//             ) : null
//         )}
//
//       <Form.Item
//         label="Phone Number"
//         name="phone_number"
//         rules={[{ required: true, message: "Please enter the phone number" }]}
//       >
//           <PhoneInput
//               defaultCountry="US"
//               placeholder="Enter phone number"
//               value={value}
//               required
//               onChange={setValue}
//               error={value ? (isValidPhoneNumber(value) ? undefined : 'Invalid phone number') : 'Phone number required'}/>
//       </Form.Item>
//
//         {showSpouseName && (
//             <Form.Item name="spouse_name" label="Spouse Name"
//                 // rules={[{ required: true, message: "Please enter the spouse name" }]}
//             >
//                 <Input />
//             </Form.Item>
//         )}
//
//       {showExtraFields && (
//         <>
//           <Form.Item name="role" label="Status">
//               <Select>
//                   <Select.Option value="client">Client</Select.Option>
//                   <Select.Option value="contact">Contact</Select.Option>
//               </Select>
//           </Form.Item>
//
//         <Form.Item name="expiry_date" label="Client Expiration Date">
//             <Input disabled={true} />
//         </Form.Item>
//             <p>(determined via signed document field)</p>
//
//             {/*<Form.Item name="uid" label="UID">*/}
//           {/*  <Input disabled />*/}
//           {/*</Form.Item>*/}
//         </>
//       )}
//
//       <Form.Item>
//         <Button type="primary" htmlType="submit">
//           Save
//         </Button>
//         <Button style={{ marginLeft: "8px" }} onClick={onCancel}>
//           Cancel
//         </Button>
//       </Form.Item>
//     </Form>
//   );
// };
//
// export default ClientForm;
